<template>
    <div ref="svgContainer" class="courier_aggregator_icon">
    </div>
</template>

<script>

import insertSvg from "../../mixins/insertSvg";

export default {
    name: "couriers_page",
    props: {
        iconSvg: {
            type: String,
            required: true,
            default: ''
        }
    },
    components: {
    },
    mixins: [insertSvg],
    mounted() {
        if (this.iconSvg && this.iconSvg !== '') {
            this.insertSvg(this.iconSvg);
        }
    },
}
</script>
